import {environment} from "../../environments/environment";
import { activeLanguageKey } from "./language.config";

export function RedirectToChangePassword() {
  const currentUrlWithoutParams = CutParamsFromUrl(window.location.href)
  const url = environment.authConfig.issuer + '/Manage/ChangePassword' + '?returnUrl=' + currentUrlWithoutParams + '?passwordChanged=true' + '&culture=' + localStorage.getItem(activeLanguageKey) || environment.language;
  window.location.href = url;
}

export function CutParamsFromUrl(url: string) {
  const questionMarkIndex = url.indexOf('?');
  return questionMarkIndex === -1 ? url : url.slice(0, questionMarkIndex);
}
